import React from "react";
import { Box, Grid, IconButton, Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { css } from "./styles";

export function DownloadConcluido({ toggleModal }) {
    const styles = css();
    return (
        <Grid container className={styles.container}>
            <Box className={styles.header}>
                <Typography className={styles.title}>DOWNLOAD ETIQUETA DE EXPEDIÇÃO</Typography>

                <IconButton className={styles.closeButton} onClick={toggleModal}>
                    <Close />
                </IconButton>
            </Box>

            <Grid item className={styles.text}>
                Consulte o manual de embalagens em caso de dúvidas sobre o uso das etiquetas e dos
                arquivos baixados.
            </Grid>
        </Grid>
    );
}
